import { useTranslation } from 'react-i18next'
import { UserManualSV } from '@/components/manual/UserManualSV'
import { UserManualEN } from '@/components/manual/UserManualEN'

export function UserManualPage() {
  const { i18n } = useTranslation()

  // Show complete manual based on language instead of using tokens
  return i18n.language === 'sv' ? <UserManualSV /> : <UserManualEN />
}
